export default __webpack_public_path__ + "static/media/card-img-4.ac8a541d.svg";